<!--班车时刻表详情-->
<template>
  <div class="tw-bcxq">
    <div class="tw-bcxq-head">
      <div class="tw-bcxq-head-title">班车时刻表</div>
      <van-icon
        name="arrow-left"
        size="30"
        color="#fff"
        @click="handleBackClick"
        class="tw-bcxq-head-icon"
      />
    </div>
    <div class="tw-bcxq-body">
      <div class="tw-bcxq-body-head">
        <div class="tw-bcxq-body-head-left">
          <input
            type="text"
            v-model="searchdate"
            class="tw-bcxq-body-head-left-input"
            @click="handleTimeFocus"
          />
        </div>
        <div class="tw-bcxq-body-head-right">
          <van-button type="info" class="tw-bcxq-body-head-right-btn">查&nbsp;询</van-button>
        </div>
      </div>
      <div class="tw-bcxq-body-mid">
        <div class="tw-bcxq-body-mid-info">
          <div class="tw-bcxq-body-mid-info-body">
            <v-touch
              style="height:100%;width:100%;"
              v-on:swipeleft="onSwipeLeft"
              v-on:swiperight="onSwipeRight"
              tag="div"
            >
              <specific-frequency></specific-frequency>
            </v-touch>
          </div>
        </div>
        <div class="tw-bcxq-body-mid-bottom">
          <div class="tw-bcxq-body-mid-bottom-left" @click="onSwipeLeft">
            <van-icon
              name="arrow-left"
              size="20"
              color="#fff"
              class="tw-bcxq-body-mid-bottom-left-icon"
            />
          </div>
          <div class="tw-bcxq-body-mid-bottom-right" @click="onSwipeRight">
            <van-icon
              name="arrow"
              size="20"
              color="#fff"
              class="tw-bcxq-body-mid-bottom-right-icon"
            />
          </div>
        </div>
      </div>
    </div>
    <van-datetime-picker
      v-if="timeDisplay"
      class="date-picker"
      type="date"
      :min-date="minDate"
      v-model="choosedate"
      :max-date="maxDate"
      @confirm="handleDatetimePickerConfirm"
      @cancel="handleDatetimePickerCancel"
    ></van-datetime-picker>
  </div>
</template>

<script>
import moment from "moment";
import SpecificFrequency from "components/SpecificFrequency";

export default {
  name: "BusDetails",
  data() {
    return {
      searchdate: moment(new Date()).format("YYYY-MM-DD"),
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      timeDisplay: false,
      choosedate: new Date(),
    };
  },
  methods: {
    //头部返回
    handleBackClick() {
      window.history.go(-1);
    },
    handleDatetimePickerConfirm(val) {
      this.searchdate = moment(val).format("YYYY-MM-DD");
      this.timeDisplay = false;
    },
    handleDatetimePickerCancel() {
      this.timeDisplay = false;
    },

    handleTimeFocus() {
      this.timeDisplay = true;
    },
    onSwipeLeft() {
      console.info("向左");
    },
    onSwipeRight() {
      console.info("向右");
    },
  },
  components: {
    SpecificFrequency,
  },
};
</script>

<style lang="scss" scoped>
.tw-bcxq {
  height: 100%;
  &-head {
    height: 6%;
    background-color: #3bacff;
    position: relative;
    &-title {
      text-align: center;
      font-size: 20px;
      font-weight: 700;
      letter-spacing: 5px;
      padding-top: 4%;
      color: #ffffff;
      box-sizing: border-box;
    }
    &-icon {
      position: absolute;
      left: 2%;
      top: 20%;
    }
  }
  &-body {
    height: 94%;
    &-head {
      height: 5%;
      display: flex;
      &-left {
        width: 70%;
        height: 100%;
        &-input {
          margin-top: 3%;
          margin-left: 8%;
          width: 80%;
          height: 62%;
        }
      }
      &-right {
        width: 30%;
        height: 100%;
        &-btn {
          margin-top: 7%;
          width: 70%;
          height: 80%;
          border-radius: 12px;
          background-color: #3bacff;
        }
      }
    }
    &-mid {
      height: 95%;
      &-info {
        height: 80%;
        &-body {
          padding: 20px;
          height: 100%;
          width: 100%;
          box-sizing: border-box;
        }
      }
      &-bottom {
        display: flex;
        height: 20%;
        position: relative;
        &-left {
          position: absolute;
          left: 10%;
          top: 10%;
          height: 40px;
          width: 40px;
          background-color: #3bacff;
          border-radius: 50%;
          &-icon {
            top: 20%;
            left: 20%;
          }
        }
        &-right {
          position: absolute;
          right: 10%;
          top: 10%;
          background-color: #3bacff;
          height: 40px;
          width: 40px;
          border-radius: 50%;
          &-icon {
            top: 20%;
            left: 25%;
          }
        }
      }
    }
  }
}
.date-picker {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px solid #9a9fa5;
  animation: mymove 0.8s;
  -webkit-animation: mymove 0.8s; /*Safari and Chrome*/
}
@keyframes mymove {
  from {
    bottom: -55%;
  }
  to {
    bottom: 0%;
  }
}
/*Safari and Chrome*/
@-webkit-keyframes mymove {
  from {
    bottom: -55%;
  }
  to {
    bottom: 0%;
  }
}
</style>
